













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Toast } from 'vant';
import personalInformation from '@/components/common/personalInformation.vue';
import userModel from '@/store/modules/user';
import SessionModule from '@/store/modules/session';

@Component({ components: { personalInformation } })
export default class LocalForm extends Vue {
  phone: string = '';
  verificationCode: string = '';
  count: number = 0;
  timer: any = null;
  show: boolean = true;
  showEditPersonInfo: boolean = false;

  get SmsType() {
    return models.SmsType;
  }

  async getCode() {
    if (this.phone.length < 1) {
      Dialog.alert({
        title: '提示',
        message: '请输入手机号。',
      });
      return;
    }
    if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.phone)) {
      const result = await api.AccountApp.localSendSms_POST({
        Phone: this.phone,
        Type: this.SmsType.登录验证,
      });
      if (result.success) {
        const TIME_COUNT = 30;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        Toast(result.message);
      }
    } else {
      Toast.fail('请输入正确的手机号码');
    }
  }

  /**手机短信验证码验证 */
  async validateCode(values) {
    try {
      const data = await api.AccountApp.validateCode_POST({
        Phone: values.phone,
        VerCode: values.verificationCode,
      });
      if (data.success) this.showEditPersonInfo = true;
      else Toast(data.message);
    } catch (error) {
      console.log(error);
    }
  }

  async onSubmit(values: any) {
    this.showEditPersonInfo = true;
    // this.validateCode(values);
    // await this.localLogin('1234563', 'ff194be84316f2e86398ca497ab602c0');
  }
  async localLogin(phone: string, token: string) {
    if (token.length < 1) {
      Dialog.alert({
        message: 'token不能为空。',
        title: '提示',
      });
      return;
    }
    if (phone.length < 1) {
      Dialog.alert({
        message: '手机号不能为空。',
        title: '提示',
      });
      return;
    }
    const result = await api.AccountApp.login_POST({ Phone: phone, Accesstoken: token });
    if (result.success) {
      const data = result.data;
      data['username'] = phone;
      const time = new Date(new Date().getTime() + data.expires_in * 1000);
      await userModel.SetData({
        refresh_token: '',
        expires_time: time,
        token: data.access_token,
      });
      await userModel.SetUserInfo(data);
      SessionModule.ACTIVE_USER({
        userId: data.userId,
        deptName: data.deptName,
        userName: phone,
        name: data.name,
        token: data.access_token,
        refresh_token: '',
        expires_time: time,
        userType: data.userType,
      });
      const classId = this.$route.query?.classId?.toString();
      const opreateType = this.$route.query?.opreateType?.toString();
      const classType = this.$route.query?.classType?.toString();
      this.$router.push({
        name: 'home',
        query: {
          classId: classId,
          opreateType: opreateType,
          classType: classType,
        },
      });
    } else {
      Dialog.alert({
        message: result.message,
        title: '提示',
      });
    }
  }

  /**填写信息注册成功的回调 */
  registerSuccess(data) {
    console.log('注册成功');
    this.showEditPersonInfo = false;
    this.$emit('localRegister', data);
  }
}
